module.exports = __webpack_public_path__ + "static/media/Asset_logo_3.ee875244.svg";